import Hero from "components/Landing/Hero";
import FeatureOne from "components/Landing/FeatureOne";
import FeatureTwo from "components/Landing/FeatureTwo";
import Solutions from "components/Landing/Solutions";
import Financial from "components/Landing/Financial";
import FAQ from "components/Landing/FAQ";

const HomepageContainer = () => {
  return (
    <div className="w-full text-white-100">
      
      <Hero />
      <FeatureOne />
      <FeatureTwo />
      <Solutions />
      <Financial />
      <FAQ />
    </div>
  );
};

export default HomepageContainer;
